<template>
  <!--滚动背景-->
  <b-carousel :interval="1000000" style="text-shadow: 0px 0px 2px #000" controls indicators>
    <!-- <b-carousel-slide caption="全网售票" text="" img-src="../../assets/images/index/banner-2.jpg"></b-carousel-slide>
    <b-carousel-slide caption="大数据中心" text="" img-src="../../assets/images/index/banner-3.jpg"></b-carousel-slide>
    <b-carousel-slide caption="客流监控" text="" img-src="../../assets/images/index/banner-4.jpg"></b-carousel-slide>
    <b-carousel-slide caption="运营服务" text="" img-src="../../assets/images/index/banner-5.jpg"></b-carousel-slide> -->
    <b-carousel-slide caption="景区票务系统定制化提供商" :caption-html="captionHtmls[0]" :text-html="textHtmls[0]" text="不同业态、不同类型的企业用户，信息化需求不同，其管理特点各不相同，用某一种既定的软件产品来满足不同类型的信息化需求，其适用性可想而知" img-src="../../assets/images/index/banner/1.png"></b-carousel-slide>
    <b-carousel-slide caption="智慧景区规划建设服务商" :caption-html="captionHtmls[1]" :text-html="textHtmls[1]" text="对同一个企业来说，所处的发展阶段不同，也存在不同的管理需求。企业发展的初期，协同办公就能满足需求；快速成长期，扁平化业务流程就能满足需求；成熟稳定期，则需要业务流，资金流，物流的协调发展" img-src="../../assets/images/index/banner/2.png"></b-carousel-slide>
    <b-carousel-slide caption="系统稳定决定为了承载的责任" :caption-html="captionHtmls[2]" :text-html="textHtmls[2]" text="容灾技术支撑、双线路架构设计、定制化驻场服务三大体系为您保驾护航" img-src="../../assets/images/index/banner/3.png"></b-carousel-slide>
    <b-carousel-slide caption="技术因业务而去改变" :caption-html="captionHtmls[3]" :text-html="textHtmls[3]" text="前端模块化管理、易于组织与重构、高速的底层处理能力、我们的一起努力为高并发、精准数据而生" img-src="../../assets/images/index/banner/4.png"></b-carousel-slide>
  </b-carousel>
</template>

<script>
import Vue from "vue";
import { CarouselPlugin } from "bootstrap-vue";

Vue.use(CarouselPlugin);

export default {
  data() {
    return {
      captionHtmls: [
        `<h1>景区票务系统定制化提供商</h1>
      <h2>Customized provider</h2>`,
        `<h1>智慧景区规划建设服务商</h1>
      <h2>Intelligent planning maker</h2>`,
        `<h1>系统稳定，才能实现承载的责任</h1>
      <h2>stability is everything</h2>`,
        `<h1>技术因业务而去改变</h1>
      <h2>Keep Change</h2>`
      ],
      textHtmls: [
        `<p>不同业态、不同类型的企业用户，信息化需求不同，其管理特点各不相同，用某一种既定的软件产品来满足不同类型的信息化需求，其适用性可想而知</p>`,
        `<p>对同一个企业来说，所处的发展阶段不同，也存在不同的管理需求。企业发展的初期，协同办公就能满足需求；快速成长期，扁平化业务流程就能满足需求；成熟稳定期，则需要业务流，资金流，物流的协调发展</p>`,
        `<p>容灾技术支撑、双线路架构设计、定制化驻场服务三大体系为您保驾护航</p>`,
        `<p>前端模块化管理、易于组织与重构、高速的底层处理能力、我们的一起努力为高并发、精准数据而生</p>`
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.carousel {
  // display: flex;
  // flex-direction: column;

  ::v-deep .carousel-caption {
    margin-bottom: 0.5rem;
  }

  ::v-deep .carousel-indicators {
    margin-bottom: 0.5rem;
  }

  ::v-deep h1 {
    font-size: 0.19rem;
    // margin-bottom: 0.1rem;
  }
  ::v-deep h2 {
    font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS",
      sans-serif;
    font-size: 0.27rem;
    font-weight: 100;
    color: #7bdbba;
    text-transform: uppercase;
    // border-bottom: 1px solid #00ffd3;
    // text-align: center;
    // width: 40vw;
  }

  ::v-deep ol {
    margin-bottom: 0.12rem;
  }

  ::v-deep p {
    font-size: 0.09rem;
  }
}
</style>